import { MainContainer } from "@wot/components";
import { formatRelative, parseJSON } from "date-fns";
import { enUS } from 'date-fns/esm/locale';
import { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { useAppSelector } from "../../hooks/useRedux";
import { notificationsApi } from "../../api/notifications";

type NotificationType = "EMAIL" | "IN_APP" | "PUSH"
interface Email {
  to: string
  templateId: string,
  dynamicTemplateData: { [x: string]: any }
}

interface INotification {
  _id: string
  title?: string,
  description?: string,
  email?: Email
  userId: string,
  actionUrl?: string,
  metadata: {
  },
  read?: boolean
  type: NotificationType,
  triggerAt: number
  createdAt: Date

}

export default function Notifications() {
  const [notifications, setNofitications] = useState<INotification[]>([]);
  const { profile } = useAppSelector(state => state.profileSlice);

  useEffect(() => {
    if (!profile) return;
    notificationsApi.get(profile?._id)
      .then((data) => setNofitications(data))
      .catch(err => err);

  }, []);

  const remove = (id: string) => {
    notificationsApi.remove(id)
      .then(() => {
        setNofitications(notifications.filter((n) => n._id !== id));
      })
      .catch(err => err);
  }

  return (
    <MainContainer>
      <div className="bg-white p-6">
        <h1 className="text-2xl font-semibold text-center">Notifications</h1>
        {notifications.length === 0 &&
          <div className="min-h-[256px] flex items-center justify-center">
            <h1 className="text-xl font-medium">No Notifications Found.</h1>
          </div>
        }
        <div className="flex flex-col gap-4 items-center my-4">
          {notifications.map((n) => <Notification notification={n} key={n._id} remove={remove} />)}
        </div>
      </div>
    </MainContainer >
  )
}

function Notification({ notification, remove }: { notification: INotification, remove: (id: string) => void }) {

  useEffect(() => {
    if (!notification.read) {
      notificationsApi.markAsRead(notification._id)
    }
  }, []);

  var formatRelativeLocale = {
    lastWeek: "'last' eeee p",
    yesterday: "'yesterday' p",
    today: "'today' p",
    tomorrow: "'tomorrow' p",
    nextWeek: "eeee p",
    other: 'dd MMM P'
  }
  const locale = {
    ...enUS,
    // @ts-ignore
    formatRelative: (token: any) => formatRelativeLocale[token],
  };

  return (
    <div className="w-full max-w-[600px] flex gap-6 items-start justify-between border border-neutralBlue1 rounded-lg p-6">
      <div className="flex flex-col gap-2">
        <h1 className={`text-base ${!notification.read ? "font-bold" : "font-medium"}`}>{notification.title}</h1>
        {notification.description &&
          <p className="text-sm">{notification.description}</p>
        }
      </div>
      <div className="flex gap-4">
        <p className="text-sm text-gray-400">{formatRelative(parseJSON(notification.triggerAt), new Date(), { locale })}</p>
        <MdClose className="text-xl cursor-pointer" onClick={() => remove(notification._id)} />
      </div>
    </div>
  )
}